import { TODO_REMINDER } from "../constants/constant";
import { t } from "i18next";


export interface IaddReminderValidators {
  [TODO_REMINDER]: {
    required: string;
    validate: any;
  };
}
export const addReminderValidators: IaddReminderValidators = {
  [TODO_REMINDER]: {
    required: t("DoctorDashbord.DateAndTime_Validation"),
    validate: {
      futureDate: (value: any) => {
        const currentDate = new Date();
        const selectedDate = new Date(value);
        if (selectedDate <= currentDate) {
          return t("DoctorDashbord.TodoReMinder")
        }
        return true;
      },
    },
  },
};
